export default "__VITE_ASSET__BJqfgLVM__"